module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "copy"
  }, [_c('a', {
    attrs: {
      "id": "ch00_fm05"
    }
  }), _c('a', {
    attrs: {
      "id": "page_4"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Copyright © 2006 by The Literary Estate of Mo Hayder")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("All rights reserved. No part of this book may be reproduced in any form or by any electronic or mechanical means, or the facilitation thereof, including information storage and retrieval systems, without permission in writing from the publisher, except by a reviewer, who may quote brief passages in a review. Any members of educational institutions wishing to photocopy part or all of the work for classroom use, or publishers who would like to obtain permission to include the work in an anthology, should send their inquiries to Grove/Atlantic, Inc., 841 Broadway, New York, NY 10003.")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("First published in great Britian in 2006 by Bantam Press, a division of Transworld Publishers")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_c('em', [_vm._v("Printed in the United States of America")])]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Hayder, Mo."), _c('br'), _vm._v("Pig island / Mo Hayder."), _c('br'), _vm._v("p.   cm."), _c('br'), _vm._v("eBook ISBN-13: 978-1-5558-4855-2"), _c('br'), _vm._v("1. Journalists—Fiction. 2. Supernatural—Fiction."), _c('br'), _vm._v("3. Scotland—Fiction. I. Title"), _c('br'), _vm._v("PR6058.A688594P545 2007"), _c('br'), _vm._v("813’.54—dc22      2006047236")]), _vm._v(" "), _c('p', {
    staticClass: "copyx"
  }, [_vm._v("Atlantic Monthly Press"), _c('br'), _vm._v("an imprint of Grove/Atlantic, Inc."), _c('br'), _vm._v("841 Broadway"), _c('br'), _vm._v("New York, NY 10003")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Distributed by Publishers Group West")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "http://www.groveatlantic.com",
      "target": "_blank"
    }
  }, [_vm._v("www.groveatlantic.com")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-322f22f8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch00_fm05.vue
// module id = 75
// module chunks = 0